/* HEALIE® Recenze – widget na produktové stránce. Líně se inicializuje při scrollu.
   3. 9. 2026: kompaktní layout (souhrn vlevo, recenze jako citáty vpravo) – styly v healie-recenze-kompakt.css */
(function () {
  var root = document.getElementById("healie-recenze");
  if (!root || root.dataset.brInit) return;
  root.dataset.brInit = "1";

  var productId = root.dataset.productId;
  var handle = root.dataset.handle;
  var heading = root.dataset.heading || "Recenze zákazníků";

  var state = { page: 1, stars: 0, media: false, sort: "nejnovejsi", data: null, items: [], expanded: false };
  var mediaIndex = []; // ploché pole médií pro lightbox: {type,url,name,rating}
  var AVATAR_COLORS = ["#14b8a6", "#f472b6", "#f59e0b", "#6366f1", "#10b981", "#ef4444", "#8b5cf6", "#0ea5e9"];

  // ikonky (jednotný tah, žádné emoji – v každém prohlížeči vypadají stejně)
  var ICON = {
    check: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    camera: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    thumb: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/></svg>',
    play: '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86a1 1 0 0 0-1.5.86z"/></svg>',
  };
  function verifiedBadge() {
    return '<span class="br-verified">' + ICON.check + " Ověřený nákup</span>";
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function stars(n, cls) {
    var out = "";
    for (var i = 1; i <= 5; i++) out += '<span class="' + (i <= n ? "" : "off") + '">★</span>';
    return '<span class="br-review-stars' + (cls ? " " + cls : "") + '" aria-label="' + n + ' z 5">' + out + "</span>";
  }
  function avatar(name) {
    var initials = name.split(/\s+/).map(function (p) { return p[0] || ""; }).join("").slice(0, 2).toUpperCase();
    var hash = 0;
    for (var i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) % 997;
    var color = AVATAR_COLORS[hash % AVATAR_COLORS.length];
    return '<span class="br-avatar" style="background:' + color + '">' + esc(initials) + "</span>";
  }
  function fmtDate(d) {
    try {
      return new Date(d).toLocaleDateString("cs-CZ", { year: "numeric", month: "long", day: "numeric" });
    } catch (e) { return ""; }
  }
  function plural(n) {
    if (n === 1) return "1 recenze";
    if (n >= 2 && n <= 4) return n + " recenze";
    return n + " recenzí";
  }

  function fetchData(append) {
    var q = "/apps/recenze/reviews?product_id=" + encodeURIComponent(productId) +
      "&page=" + state.page + "&sort=" + state.sort +
      (state.stars ? "&stars=" + state.stars : "") + (state.media ? "&media=1" : "");
    return fetch(q).then(function (r) { return r.json(); }).then(function (data) {
      state.data = data;
      state.items = append ? state.items.concat(data.reviews) : data.reviews;
      render();
    }).catch(function () {
      root.innerHTML = '<p class="br-empty">Recenze se nepodařilo načíst.</p>';
    });
  }

  function formUrl() {
    return "/apps/recenze/napsat?product_id=" + encodeURIComponent(productId) + "&handle=" + encodeURIComponent(handle);
  }

  function mediaThumb(m, idx, size) {
    if (m.type === "photo") {
      return '<button type="button" class="br-thumb" data-idx="' + idx + '" aria-label="Zvětšit fotku"><img loading="lazy" src="' + esc(m.thumb || m.url) + '" alt="Fotka od zákazníka"></button>';
    }
    // video se načte až po kliknutí (lazy); náhledový snímek pokud existuje
    return '<button type="button" class="br-thumb br-thumb-video" data-idx="' + idx + '" aria-label="Přehrát video">' +
      (m.thumb ? '<img loading="lazy" src="' + esc(m.thumb) + '" alt="Video od zákazníka">' : "") +
      '<span class="br-play">' + ICON.play + "</span></button>";
  }

  function render() {
    var d = state.data;
    var agg = d.aggregate;
    mediaIndex = [];
    var LIMIT = 3; // viditelné recenze před rozbalením
    var overenych = state.items.filter(function (r) { return r.verified; }).length;
    var vsechnyNacteny = state.items.length >= d.total;

    var html = '<div class="brk">';

    // levý sloupec – tichý souhrn
    html += '<aside class="brk-souhrn">';
    html += '<p class="brk-stitek">' + esc(heading) + "</p>";
    if (agg.count) {
      html += '<div class="brk-cislo">' + agg.avg.toLocaleString("cs-CZ", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "</div>";
      html += '<div class="brk-hvezdy">' + stars(Math.round(agg.avg)) + "</div>";
      html += '<div class="brk-pocet">' + plural(agg.count) +
        (vsechnyNacteny && overenych && !state.media && !state.stars ? " · " + overenych + " s ověřeným nákupem" : "") + "</div>";
    } else {
      html += '<div class="brk-pocet brk-pocet--nic">Zatím žádné recenze. Buďte první!</div>';
    }
    html += '<a class="brk-btn" href="' + formUrl() + '">Napsat recenzi</a>';
    html += '<p class="brk-hint">' + ICON.camera + " Za recenzi s fotkou nebo videem sleva na další nákup.</p>";
    html += '<button type="button" class="br-verify-toggle brk-verify">Jak ověřujeme recenze</button>' +
      '<div class="br-verify-text">' + esc(d.verificationText) + "</div>";
    html += "</aside>";

    // pravý sloupec – recenze jako citáty
    html += '<div class="brk-obsah">';
    if (d.gallery && d.gallery.length) {
      html += '<div class="brk-galerie"><div class="brk-galerie-titulek">Fotky a videa od zákazníků (' + d.gallery.length + ')</div><div class="br-gallery-strip">';
      d.gallery.forEach(function (m) {
        var idx = mediaIndex.length;
        mediaIndex.push(m);
        html += mediaThumb(m, idx);
      });
      html += "</div></div>";
    }
    if (agg.count >= 6 || state.media) {
      html += '<div class="brk-nastroje">' +
        '<button type="button" class="brk-chip' + (!state.media ? " on" : "") + '" data-reset="1">Vše</button>' +
        '<button type="button" class="brk-chip' + (state.media ? " on" : "") + '" data-media="1">S fotkou / videem</button>' +
        '<select class="br-sort brk-sort" aria-label="Řazení">' +
        '<option value="nejnovejsi"' + (state.sort === "nejnovejsi" ? " selected" : "") + ">Nejnovější</option>" +
        '<option value="nejuzitecnejsi"' + (state.sort === "nejuzitecnejsi" ? " selected" : "") + ">Nejužitečnější</option>" +
        "</select></div>";
    }
    html += '<div class="brk-seznam">';
    if (!state.items.length) {
      html += '<p class="br-empty">' + (agg.count ? "Filtru neodpovídá žádná recenze." : "Napište první recenzi a pomozte ostatním s výběrem.") + "</p>";
    }
    state.items.forEach(function (r, i) {
      var skryta = !state.expanded && i >= LIMIT;
      html += '<article class="brk-rec' + (skryta ? " brk-rec--skryta" : "") + '">';
      html += '<span class="brk-uvozovka" aria-hidden="true">“</span>';
      if (r.title) html += '<p class="brk-nazev">' + esc(r.title) + "</p>";
      if (r.body) html += '<p class="brk-text">' + esc(r.body) + "</p>";
      html += '<div class="brk-meta"><span class="brk-jmeno">' + esc(r.name) + "</span>" +
        (r.verified ? verifiedBadge() : "") + stars(r.rating) +
        '<span class="brk-datum">' + fmtDate(r.date) + "</span></div>";
      if (r.media && r.media.length) {
        html += '<div class="br-media">';
        r.media.forEach(function (m) {
          var idx = mediaIndex.length;
          mediaIndex.push({ type: m.type, url: m.url, thumb: m.thumb, name: r.name, rating: r.rating, title: r.title, body: r.body, verified: r.verified, date: r.date });
          html += mediaThumb(m, idx);
        });
        html += "</div>";
      }
      if (r.reply) html += '<div class="brk-odpoved"><b>Odpověď HEALIE®</b>' + esc(r.reply) + "</div>";
      html += '<button type="button" class="brk-uzitecne' + (isVoted(r.id) ? " voted" : "") + '" data-helpful="' + r.id + '">' + ICON.thumb + " Užitečné (" + r.helpful + ")</button>";
      html += "</article>";
    });
    html += "</div>";
    if (!state.expanded && state.items.length > LIMIT) {
      html += '<button type="button" class="brk-vice" data-expand="1">Zobrazit všechny recenze (' + d.total + ") →</button>";
    } else if (state.items.length < d.total) {
      html += '<button type="button" class="brk-vice br-more">Načíst další recenze →</button>';
    }
    html += "</div></div>";

    root.innerHTML = html;
    bind();
  }

  function isVoted(id) {
    try { return (localStorage.getItem("br_voted") || "").indexOf(id) !== -1; } catch (e) { return false; }
  }
  function markVoted(id) {
    try { localStorage.setItem("br_voted", (localStorage.getItem("br_voted") || "") + "," + id); } catch (e) {}
  }

  function bind() {
    root.querySelectorAll(".br-bar-row").forEach(function (b) {
      b.addEventListener("click", function () {
        var s = Number(b.dataset.stars);
        state.stars = state.stars === s ? 0 : s;
        state.page = 1;
        fetchData(false);
      });
    });
    root.querySelectorAll("[data-reset]").forEach(function (b) {
      b.addEventListener("click", function () {
        state.stars = 0; state.media = false; state.page = 1;
        fetchData(false);
      });
    });
    root.querySelectorAll("[data-reset-stars]").forEach(function (b) {
      b.addEventListener("click", function () { state.stars = 0; state.page = 1; fetchData(false); });
    });
    root.querySelectorAll("[data-media]").forEach(function (b) {
      b.addEventListener("click", function () { state.media = !state.media; state.page = 1; fetchData(false); });
    });
    var sortEl = root.querySelector(".br-sort");
    if (sortEl) sortEl.addEventListener("change", function () { state.sort = sortEl.value; state.page = 1; fetchData(false); });
    root.querySelectorAll("[data-expand]").forEach(function (b) {
      b.addEventListener("click", function () { state.expanded = true; render(); });
    });
    var more = root.querySelector(".br-more");
    if (more) more.addEventListener("click", function () { state.page++; fetchData(true); });
    var vt = root.querySelector(".br-verify-toggle");
    if (vt) vt.addEventListener("click", function () { root.querySelector(".br-verify-text").classList.toggle("open"); });
    root.querySelectorAll(".br-thumb").forEach(function (t) {
      t.addEventListener("click", function () { openLightbox(Number(t.dataset.idx)); });
    });
    root.querySelectorAll("[data-helpful]").forEach(function (b) {
      b.addEventListener("click", function () {
        var id = b.dataset.helpful;
        if (isVoted(id)) return;
        markVoted(id);
        b.classList.add("voted");
        b.innerHTML = ICON.thumb + " Užitečné (" + (Number((b.textContent.match(/\((\d+)\)/) || [0, 0])[1]) + 1) + ")";
        fetch("/apps/recenze/submit", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "helpful", review_id: id }),
        }).catch(function () {});
      });
    });
  }

  var lightboxEl = null;
  function openLightbox(idx) {
    closeLightbox();
    var m = mediaIndex[idx];
    if (!m) return;
    lightboxEl = document.createElement("div");
    lightboxEl.className = "br-lightbox";
    // bez atributu autoplay – téma skrývá video[autoplay]:not([muted]);
    // přehrání spustíme JavaScriptem níže (klik uživatele = zvuk povolen)
    var content = m.type === "photo"
      ? '<img src="' + esc(m.url) + '" alt="Fotka od zákazníka">'
      : '<video src="' + esc(m.url) + '"' + (m.thumb ? ' poster="' + esc(m.thumb) + '"' : "") + ' controls playsinline></video>';
    // panel s celou recenzí vedle média
    var panel = "";
    if (m.name) {
      panel = '<aside class="br-lightbox-panel">' +
        '<div class="br-lightbox-panel-head">' + stars(m.rating || 5) +
        '<span class="br-review-name">' + esc(m.name) + "</span>" +
        (m.verified ? verifiedBadge() : "") + "</div>" +
        (m.date ? '<div class="br-lightbox-panel-date">' + fmtDate(m.date) + "</div>" : "") +
        (m.title ? '<div class="br-review-title">' + esc(m.title) + "</div>" : "") +
        (m.body ? '<div class="br-lightbox-panel-body">' + esc(m.body) + "</div>" : "") +
        "</aside>";
    }
    lightboxEl.innerHTML =
      '<button type="button" class="br-lightbox-close" aria-label="Zavřít">×</button>' +
      (mediaIndex.length > 1 ? '<button type="button" class="br-lightbox-nav br-lightbox-prev" aria-label="Předchozí">‹</button>' : "") +
      '<div class="br-lightbox-inner"><div class="br-lightbox-media">' + content + "</div>" + panel + "</div>" +
      (mediaIndex.length > 1 ? '<button type="button" class="br-lightbox-nav br-lightbox-next" aria-label="Další">›</button>' : "");
    document.body.appendChild(lightboxEl);
    var vid = lightboxEl.querySelector("video");
    if (vid) vid.play().catch(function () {});
    lightboxEl.addEventListener("click", function (e) {
      if (e.target === lightboxEl || e.target.classList.contains("br-lightbox-close")) closeLightbox();
      if (e.target.classList.contains("br-lightbox-prev")) openLightbox((idx - 1 + mediaIndex.length) % mediaIndex.length);
      if (e.target.classList.contains("br-lightbox-next")) openLightbox((idx + 1) % mediaIndex.length);
    });
    // swipe na mobilu: doleva = další, doprava = předchozí, nahoru/dolů = zavřít
    var touchX = null, touchY = null;
    lightboxEl.addEventListener("touchstart", function (e) {
      if (e.touches.length === 1) { touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; }
    }, { passive: true });
    lightboxEl.addEventListener("touchend", function (e) {
      if (touchX === null || e.target.closest("video")) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = touchY = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && mediaIndex.length > 1) {
        openLightbox(dx < 0 ? (idx + 1) % mediaIndex.length : (idx - 1 + mediaIndex.length) % mediaIndex.length);
      } else if (Math.abs(dy) > 70 && Math.abs(dy) > Math.abs(dx) * 1.5) {
        closeLightbox();
      }
    }, { passive: true });
    document.addEventListener("keydown", escClose);
  }
  function escClose(e) { if (e.key === "Escape") closeLightbox(); }
  function closeLightbox() {
    if (lightboxEl) { lightboxEl.remove(); lightboxEl = null; }
    document.removeEventListener("keydown", escClose);
  }

  // líné načtení dat až při scrollu k widgetu
  function init() {
    root.innerHTML = '<h2 class="br-heading">' + esc(heading) + "</h2>" +
      '<div class="br-skeleton"><i style="width:40%"></i><i style="width:90%"></i><i style="width:70%"></i></div>';
    fetchData(false);
  }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        init();
      }
    }, { rootMargin: "400px" });
    io.observe(root);
  } else {
    init();
  }
})();
